import React, { useState, useEffect } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import Response_Processing from "../../layout/Others/Response_Processing";
import AdminDeleteModal from "../../components/CommonComponents/AdminDeleteModal";
import { ActionFormatterComponent } from "../../components/CommonMethod/CommonBoostrapFormatter";
import AdminNavbar from "../../components/CommonComponents/AdminNavbar";
import AdminHeader from "../../components/CommonComponents/AdminHeader";
import NoRecordTable from "../../components/CommonComponents/NoRecordTable";
import { toast } from "react-toastify";
import { getItemToken } from "../../Utils/localStorageUtils";

function PPVPurchasePlansList() {
  const headers = getItemToken('access_token');
  const BaseUrl = process.env.REACT_APP_Baseurl;

  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withoutRefresh, setWithoutRefresh] = useState(false);

  const ppvFormatter = (data, row) => {
    return (
      <div className="d-flex justify-content-between align-items-center">
        <div className="rightVideoTitle">
          <p className="table-heading">{data}</p>
          <span className="dateText table-subheading theme-text-color">
            {row?.description?.substring(0, 50)}...
          </span>
        </div>
      </div>
    );
  };

  const statusFormatter = (cell, row) => {
    return (
      <span className={`badge ${row.is_active ? 'bg-success' : 'bg-secondary'}`}>
        {row.is_active ? 'Active' : 'Inactive'}
      </span>
    );
  };

  const priceFormatter = (cell, row) => {
    return `$${row.price}`;
  };


  const columns = [
    {
      dataField: "sno",
      text: "S.No",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      headerStyle: { width: "50px", textAlign: "center" },
      style: { textAlign: "center" },
      isDummyField: true,
      colStyle: "text-nowrap",
    },
    {
      dataField: "title",
      text: "PPV Title",
      formatter: (cell, row) => ppvFormatter(cell, row),
      headerClasses: 'video-width-table'
    },
    {
      dataField: "price",
      text: "Price",
      formatter: priceFormatter,
    },
    {
      dataField: "is_active",
      text: "Status",
      formatter: statusFormatter,
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => (
        <ActionFormatterComponent
          cell={cell}
          row={row}
          link={`/admin/ppv-purchase-plans/edit/`}
          action={singleDelete}
          hidePreview
        />
      ),
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: 'All', value: Number(filteredData?.length)
    }]
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
        }
      }
    },
    style: { width: '30px' },
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows.map((r) => r.id);
        setItemToDelete(allIds);
      } else {
        setItemToDelete([]);
      }
    },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };


  const fetchData = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/admin/ppv-purchase-plans/index`, { headers: headers });
      const result = response?.data?.data || [];

      setApiData(result);
      setFilteredData(result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error(error.response?.data?.message || 'Error fetching PPV records');
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.delete(`${BaseUrl}/admin/ppv-purchase-plans/multi-delete`, {
        data: { id: itemToDelete },
        headers: headers
      });

      if (response.data.status) {
        setWithoutRefresh(!withoutRefresh);
        toast.success(response.data.message || 'PPV record(s) deleted successfully');
        setItemToDelete([]);
      } else {
        toast.error(response.data.message || 'Error deleting PPV record(s)');
      }
      setShowOverlay(false);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error deleting PPV record(s)');
      setShowOverlay(false);
    }
  };

  const reloadAction = () => {
    setShowOverlay(true);
    setTimeout(() => {
      setShowOverlay(false);
    }, 1000);
    setWithoutRefresh(prev => !prev);
  };

  const closeModal = () => {
    setModelClose(false);
    setItemToDelete([]);
    setSelectAll(false);
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  const multipleDeleteClick = () => {
    openModal();
  };

  const handleFilterChange = (searchData) => {
    setFilteredData(searchData);
  };

  useEffect(async () => {
    await fetchData();
  }, [withoutRefresh]);

  return (
    <>
      {modelClose && (
        <AdminDeleteModal
          modelClose={modelClose}
          deleteClose={closeModal}
          deleteAction={handleDeletedata}
          buttonText={itemToDelete?.length}
        />
      )}
      {showOverlay && <Response_Processing />}

      <AdminNavbar
        heading="PPV Purchase Plans Management"
        totalDataLength={apiData?.length}
        deleteCount={itemToDelete?.length}
        navigation="/admin/ppv-purchase-plans/create"
        deleteMethod={openModal}
        navText="Add New Plan"
      />

      <div className="theme-bg-color p-3 rounded-2 bootstrapTable multi-delete-width">
        <AdminHeader
          hideExport={false}
          searchMethod={handleFilterChange}
          reduceData={filteredData}
          originalData={apiData}
          fileName="PPV-Purchase-Plans-Records"
          reload={true}
          reloadAction={reloadAction}
          loading={loading}
          customppv={true}
        />
        <BootstrapTable
          keyField="id"
          pagination={paginationFactory(options)}
          columns={columns}
          data={filteredData}
          className="no-border-table theme-text-color"
          noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />}
          hover
          headerClasses="videoWidth"
          selectRow={selectRow}
          selectAll={selectAll}
          loader={loading}
        />
      </div>
    </>
  );
}

export default PPVPurchasePlansList;
